<ng-container *ngIf="!showExport">
  <payarc-page-header title="Events & Logs"></payarc-page-header>

  <app-events-tabs></app-events-tabs>

  <payarc-filter-bar class="ev-filter-row">
    <payarc-search placeholder="Search" [value]="searchText || ''" (valueChange)="onSearch($event)"></payarc-search>
    <button actions type="button" payarcButton="primary" (click)="exportexcel()">Export</button>
  </payarc-filter-bar>

  <payarc-section-card [flush]="true">
    <payarc-table>
      <thead>
        <tr>
          <th [attr.aria-sort]="ariaSort(sortDirection('description'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('description')">Event <payarc-sort-icon [direction]="sortDirection('description')"></payarc-sort-icon></button>
          </th>
          <th [attr.aria-sort]="ariaSort(sortDirection('id'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('id')">ID <payarc-sort-icon [direction]="sortDirection('id')"></payarc-sort-icon></button>
          </th>
          <th [attr.aria-sort]="ariaSort(sortDirection('created_at'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('created_at')">Date <payarc-sort-icon [direction]="sortDirection('created_at')"></payarc-sort-icon></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="loadFlag">
          <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3]">
            <td *ngFor="let c of [1,2,3]"><span class="pa-skeleton-bar"></span></td>
          </tr>
        </ng-container>

        <tr *ngIf="!loadFlag && errorMsg">
          <td class="pa-table__state-cell" colspan="3">
            <payarc-empty-state title="No events found" [message]="errorMsg"></payarc-empty-state>
          </td>
        </tr>

        <ng-container *ngIf="!loadFlag && !errorMsg">
          <tr *ngFor="let event of eventList.data" tabindex="0" (click)="openEvent($event, event)" (keydown.enter)="openEvent($event, event)" (keydown.space)="$event.preventDefault(); openEvent($event, event)">
            <td class="strong">{{event.description ? (event.description | camalizeStr : true).replace('usd', "USD") : '--'}}</td>
            <td class="muted">{{event.id}}</td>
            <td class="muted">{{event.created_at ? (event.created_at | dateFormat: 'MM/dd/yyyy hh:mm') : '--'}}</td>
          </tr>
        </ng-container>
      </tbody>
    </payarc-table>

    <div class="ev-pager-row" *ngIf="!loadFlag && !errorMsg && eventList.data.length > 0 && metadata?.['total']">
      <label class="ev-pager-row__limit">
        Rows per page
        <select class="pa-input" [(ngModel)]="limit" (change)="setUrl()">
          <option *ngFor="let no of limitArray" [value]="no">{{ no }}</option>
        </select>
      </label>
      <payarc-pager
        [rangeLabel]="pagerRangeLabel"
        [pages]="numbers()"
        [currentPage]="metadata?.['current_page']"
        [disablePrev]="!metadata?.['links']?.['previous']"
        [disableNext]="!metadata?.['links']?.['next']"
        (prev)="pagerPrev()"
        (next)="pagerNext()"
        (pageSelect)="pagerSelect($event)"
      ></payarc-pager>
    </div>
  </payarc-section-card>
</ng-container>

<div *ngIf="showExport">
  <app-export-excel [exportExcel]="exportExcel" [serviceName]="exportData" [filterUrl]="filterPostFix" [searchData]="searchText"></app-export-excel>
</div>
